import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your email...");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      if (!token) {
        setMessage("Invalid or missing token.");
        setLoading(false);
        return;
      }

      try {
        // console.log(token,"token");
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/verify-email`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();
        

        if (response.ok) {
          setMessage("Your email has been successfully verified! You can now log in.");
          const {email, name} = data;
        const token = data.token;
              
        const obj = {token, email, name};
        localStorage.setItem("user-info", JSON.stringify(obj));

        setTimeout(() => navigate('/'), 2000);
          
        } else {
          setMessage(data.error || "Verification failed. Please try again.");
        }
      } catch (error) {
        console.error("Verification error:", error);
        setMessage("Something went wrong. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, []);

  return (
    <div style={styles.container}>
      <h1>Email Verification</h1>
      {loading ? <p style={styles.loadingText}>Loading...</p> : <p style={styles.message}>{message}</p>}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "90vh",
    // backgroundColor: "#f9f9f9",
    // fontFamily: "Arial, sans-serif",
  },
  loadingText: {
    // color: "#666",
    fontSize: "18px",
  },
  message: {
    // color: "#333",
    fontSize: "20px",
    textAlign: "center",
    marginTop: "20px",
  },
};

export default VerifyEmail;
